import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function KidsStoryDetail() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/kids-stories/${slug}`).then((r) => setS(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err)
    return (
      <div className="container-reading py-24 text-center">
        <h1 className="heading-2">Story not found.</h1>
        <Link to="/kids" className="mt-6 btn-primary inline-flex">Back to Stories</Link>
      </div>
    );
  if (!s) return <div className="container-reading py-24 text-ink-muted">Loading…</div>;

  return (
    <div className="theme-kids relative">
      <div className="absolute inset-0 bg-gradient-to-b from-[#FDF5E6] via-background to-background -z-10" aria-hidden />
      <div className="container-reading pt-16">
        <Link to="/kids" className="inline-flex items-center gap-1 text-sm text-terracotta hover:text-terracotta-dark">
          <ChevronLeft className="h-4 w-4" /> All stories
        </Link>
        <span className="inline-block mt-6 px-3 py-1 bg-terracotta/15 text-terracotta-dark text-[11px] uppercase tracking-widest">
          Ages {s.age_group}
        </span>
        <h1 className="heading-1 mt-4">{s.title}</h1>
        {s.image_url && (
          <img src={s.image_url} alt="Illustration" className="mt-8 w-full rounded-2xl aspect-[16/9] object-cover" />
        )}
        <p className="text-[11px] uppercase tracking-widest text-ink-muted mt-2">Illustration — not a historical photograph</p>
      </div>

      <div className="container-reading py-12">
        <div className="prose-editorial text-lg" dangerouslySetInnerHTML={{ __html: s.body }} />

        <div className="mt-12 storybook-card p-8">
          <p className="eyebrow text-terracotta">What we learn</p>
          <p className="mt-3 font-serif text-2xl text-ink" style={{ fontWeight: 500 }}>{s.lesson}</p>
          {s.memory_verse && (
            <>
              <p className="eyebrow mt-8 text-terracotta">Memory verse</p>
              <p className="mt-2 font-serif text-xl italic text-ink">{s.memory_verse}</p>
            </>
          )}
        </div>

        {s.parent_note && (
          <div className="mt-8 border-l-4 border-gold pl-6">
            <p className="eyebrow">For parents</p>
            <p className="mt-2 body-copy">{s.parent_note}</p>
          </div>
        )}
      </div>
    </div>
  );
}
